import React, { useCallback, memo, SyntheticEvent } from "react";
import { useAppDispatch, useAppSelector } from "stores";
import styled from "styled-components";
import store from "stores/interfaces";
import Paper from "@mui/material/Paper";
import ChatBoxHeader from "./ChatBoxHeader";
import ChatBoxToolbar from "./ChatBoxToolbar";
import ChatBoxTextField from "./ChatBoxTextField";
import ChatBoxTypingStateBar from "./ChatBoxTypingStateBar";
import { Divider } from "@mui/material";

type ChatBoxProps = {
  roomId: string;
  standalone: boolean;
};

const ChatBox = (props: ChatBoxProps) => {
  const dispatch = useAppDispatch();
  const { roomId } = props;

  const characterId = useAppSelector(store.getUserCharacterId);

  const onSubmit = useCallback(
    (e: SyntheticEvent) => {
      e.preventDefault();
      dispatch(
        store.addMessage(
          roomId,
          characterId || null,
          {},
          true,
          props.standalone
        )
      );
    },
    [dispatch, roomId, characterId, props.standalone]
  );

  return (
    <Container square>
      <Form onSubmit={onSubmit} autoComplete="off">
        <ChatBoxHeader />
        <ChatBoxToolbar />
        <ChatBoxTextField onSubmit={onSubmit} standalone={props.standalone} />
        <Divider />
        <ChatBoxTypingStateBar />
      </Form>
    </Container>
  );
};

const Container = styled(Paper)`
  position: relative;
`;

const Form = styled.form`
  background: rgba(0, 0, 0, 0.1);
`;

export default memo(ChatBox);
